/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';

( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.navbar-toggle' ).on( 'toggleAfter', ( event ) => {
        $( '.primary-nav-mobile' ).slideToggle();
      } );

      $( '.navbar .primary-nav li.primary-menu-item > button[data-toggle-target], .navbar .select-location' ).on( 'toggleAfter', function( event ) {
        $( $( event.target ).attr( 'data-toggle-target' ) ).slideToggle();
      } );

      $( '.js-init-video' ).magnificPopup( {
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        callbacks: {
          open: function() {
            $( 'video' ).trigger( 'pause' );
          },
          close: function() {
            $( 'video' ).trigger( 'play' );
          },
        },
      } );

      function handleMobileChange( event ) {
        /*
         * Remove any inline display values when the screen changes
         * between mobile and desktop state. This allows the default
         * stylings to kick in and prevent any weird "half mobile half desktop"
         * nav display states that sometimes occur while resizing the browser
         * Also remove any active is-open classes from the toggle and nav to reset
         * its state when switching between screen sizes
         */
        if ( event.matches ) {
          if ( $( '.primary-nav' ).length > 0 ) {
            $( '.primary-nav' ).get( 0 ).style.removeProperty( 'display' );

            $( '.navbar-toggle, .primary-nav' ).removeClass( 'is-open' );
          }
        }
      }

      /* Run the handleMobileChange function when the screen sizes changes based on the mobileSize const */
      const mobileSize = window.matchMedia( '(min-width: 768px)' );
      handleMobileChange( mobileSize );
      mobileSize.addEventListener( 'change', handleMobileChange );

      /* Allow selects to have placeholder styles */
      checkSelectPlaceholder();
      $( '.gfield_select' ).on( 'change', function() {
        checkSelectPlaceholder();
      } );
      function checkSelectPlaceholder() {
        if ( $( '.gfield_select' ).find( 'option:selected' ).hasClass( 'gf_placeholder' ) ) {
          $( '.gfield_select' ).addClass( 'placeholder-selected' );
        } else {
          $( '.gfield_select' ).removeClass( 'placeholder-selected' );
        }
      }

      /* Lazyload all embeds */
      if ( 'IntersectionObserver' in window ) {
        const options = {
          root: null, // avoiding 'root' or setting it to 'null' sets it to default value: viewport
          rootMargin: '0px 0px 100px', // determines how far form the root the intersection callback will trigger
        };
        const embedObserver = new IntersectionObserver( function( entries, observer ) {
          entries.forEach( function( embed ) {
            if ( embed.isIntersecting ) {
              $( embed.target ).attr( 'src', $( embed.target ).attr( 'data-src-defer' ) );
              // remove observer
              embedObserver.unobserve( embed.target );
            }
          } );
        }, options );

        // add the observer to the elements
        $( '[data-src-defer]' ).each( function( index, element ) {
          embedObserver.observe( element );
        } );
      }

      if ( $( '.footer .splide--marquee' ).length ) {
        new Splide( '.footer .splide--marquee', {
          type: 'loop',
          autoWidth: true,
        } ).mount( {AutoScroll} );
      }

      if (
        $( 'main > section:last-child' ).hasClass( 'component-rounded-both' ) ||
        $( 'main > section:last-child' ).hasClass( 'component-rounded-bottom' ) ||
        $( 'body' ).hasClass( 'single-post' ) || $( 'body' ).hasClass( 'blog' ) ||
        $( 'body' ).hasClass( 'post-type-archive-ll_bag' ) ||
        $( 'body' ).hasClass( 'single-ll_bag ' )
      ) {
        $( 'footer' ).removeClass( 'no-top-spacing' );
      }

      if ( $( '.form-skin .ll-file-upload' ).length > 0 && typeof( gform ) !== 'undefined' ) {
        $( 'input[type=\'file\']' ).on( 'change', function() {
          const fullPath = $( this ).val();
          let filename = fullPath.replace( /^.*[\\/]/, '' );
          if ( filename === '' ) {
            filename = 'No file chosen';
          }
          const theInput = $( this ).parent().find( '.ll-file-upload span' );
          $( theInput ).text( filename );
        } );
      }

      $( document ).on( 'click', '.vein-screening-tool .gform_previous_button, .vein-screening-tool .gform_next_button', function() {
        $( '.vein-screening-tool' ).addClass( 'is-loading' );
      } );

      $( '.vein-screening-tool__start' ).on( 'click', function() {
        $( '.vein-screening-tool__wrapper, .multi-page-form__footer' ).show();
        $( '.vein-screening-tool__intro' ).removeClass( 'is-active' );
      } );

      $( document ).on( 'gform_post_render', function() {
        $( '.gform_page' ).each( function() {
          const $page = $( this );
          if ( $page.find( '> .gform_page_inner' ).length ) {
            return;
          }
          $page.find( '> .gform_page_fields, > .gform_page_footer' ).wrapAll( '<div class="gform_page_inner"></div>' );
        } );
      } );

      // Mark the wrapper as final if the form only has one page
      if ( $( '.gform_page' ).length === 1 ) {
        $( '.vein-screening-tool__wrapper' ).addClass( 'is-final' );
      }

      $( document ).on( 'gform_page_loaded', function( event, formId, currentPage ) {
        if ( currentPage == $( '.gform_page' ).length ) {
          $( '.multi-page-form__footer' ).hide();
          $( '.vein-screening-tool__wrapper' ).addClass( 'is-final' );
        } else {
          $( '.multi-page-form__footer' ).show();
          $( '.vein-screening-tool__wrapper' ).removeClass( 'is-final' );
        }
      } );

      $( document ).on( 'gform_confirmation_loaded', function( event, formId ) {
        $( '.vein-screening-tool__wrapper, .multi-page-form__footer' ).hide();
        $( '.vein-screening-tool__confirmation' ).addClass( 'is-active' );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'common', COMPONENT );
} )( app );
